import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Box, Typography, Paper, Stack, IconButton, Tooltip } from '@mui/material'
import { Update } from '@mui/icons-material'

import { acSetBatchFilesTablePagination } from '../../store/actions'
import { UploadBox } from '../boxes'
import { CleanButton, PanelBox, Snackbar } from '../default'
import { BatchFileInfoModal, BatchFileUploadModal } from '../modals'
import { BatchFilesTable } from '../tables'

const BatchFileUploadPanel = () => {

    const dispatch = useDispatch()

    const [file, setFile] = useState(null)
    const [openInfoModal, setOpenInfoModal] = useState(false)
    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    useEffect(() => {
        dispatch(acSetBatchFilesTablePagination({ pageIndex: 0, pageSize: 10 }))
    }, [])

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    return (
        <PanelBox title='Consulta em Lote'>

            <BatchFileUploadModal
                open={!!file}
                onClose={() => setFile(null)}
                setSnackbarData={setSnackbarData}
                file={file}
            />

            <BatchFileInfoModal
                open={openInfoModal}
                onClose={() => setOpenInfoModal(!openInfoModal)}
            />

            {/* Card de Upload de Arquivos */}
            <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 2 }}>

                <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                    flexWrap='wrap'
                    rowGap={2}
                    columnGap={2}
                >

                    <Stack>
                        <Typography variant='h6' fontWeight='bold'>
                            Upload de arquivo CSV
                            <Typography component='span' variant='caption' color='error'> *obrigatório</Typography>
                        </Typography>

                        <Typography variant='body2'>
                            Importe um lote de clientes para processar e aplicar a política de crédito
                        </Typography>
                    </Stack>

                    <CleanButton
                        label='Dúvidas Arquivo CSV'
                        onClick={() => setOpenInfoModal(true)}
                    />
                </Box>

                <UploadBox setFile={setFile} />

            </Paper>

            {/* Card de Histórico de Lotes */}
            <Paper elevation={0} sx={{ p: 3, mb: 4, borderRadius: 2 }}>

                <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='flex-start'
                    flexWrap='wrap'
                    mb={2}
                >
                    <Box>
                        <Typography variant='h6' fontWeight='bold'>
                            Histórico de lotes processados
                        </Typography>
                        <Typography variant='body2'>
                            Acesse o resultado de lotes anteriores
                        </Typography>
                    </Box>
                    <Tooltip title='Atualizar Histórico'>
                        <IconButton
                            onClick={() => {
                                dispatch(acSetBatchFilesTablePagination({ pageIndex: 0, pageSize: 10 }))
                            }}
                        >
                            <Update />
                        </IconButton>
                    </Tooltip>
                </Box>

                <BatchFilesTable setSnackbarData={setSnackbarData} />

            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                message={snackbarData.message}
                severity={snackbarData.severity}
            />
        </PanelBox>
    )
}

export default BatchFileUploadPanel